import React from 'react';
import { Row, Col } from "antd";
import 'swiper/css';
import 'swiper/css/pagination';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from "swiper/modules"; // ✅ include Pagination too
import Img1 from '../assets/sliderImages/1.png';
import Img2 from '../assets/sliderImages/2.png';
import Img3 from '../assets/sliderImages/3.png';
import Img4 from '../assets/sliderImages/4.png';

function Template() {
  return (
    <div className="section pt-[80px] pb-[80px]">
      <div className="container">
        <Row>
          <Col md={24} xs={24}>
            <div className="text-section">
              <h2 className="text-4xl md:text-6xl font-bold text-black font-custom leading-snug md:leading-[1.3] capitalize text-center mb-5">
                Start With a Design Template
              </h2>
              <p className="text-center text-[18px] font-custom mb-4 w-[40%] pb-10 mx-auto text-[#72747C]">
                You don't have to be a designer to create great looking shirts. Pick from one of our professionally designed templates to get you started.
              </p>
            </div>
          </Col>

          <Col md={24}>
            <Swiper
              slidesPerView={4}
              spaceBetween={30}
              loop={true} // ✅ makes it continuous
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              nav={true}
              pagination={false}   // 👈 disables dots
              modules={[Autoplay, Pagination]} // ✅ register modules here
              className="mySwiper"
            >
              <SwiperSlide>
                <a href="/" className="hover:text-black">
                  <div className="flex flex-col items-center justify-center text-center">
                    <img src={Img1} alt="" className="mx-auto mb-2" />
                    <span className="font-custom text-[25px] text-center block">Sports</span>
                  </div>
                </a>
              </SwiperSlide>

              <SwiperSlide>
                <a href="/" className="hover:text-black">
                  <div className="flex flex-col items-center justify-center text-center">
                    <img src={Img2} alt="" className="mx-auto mb-2" />
                    <span className="font-custom text-[25px] text-center block">School</span>
                  </div>
                </a>
              </SwiperSlide>

              <SwiperSlide>
                <a href="/" className="hover:text-black">
                  <div className="flex flex-col items-center justify-center text-center">
                    <img src={Img3} alt="" className="mx-auto mb-2" />
                    <span className="font-custom text-[25px] text-center block">Events</span>
                  </div>
                </a>
              </SwiperSlide>

              <SwiperSlide>
                <a href="/" className="hover:text-black">
                  <div className="flex flex-col items-center justify-center text-center">
                    <img src={Img4} alt="" className="mx-auto mb-2" />
                    <span className="font-custom text-[25px] text-center block">Greek</span>
                  </div>
                </a>
              </SwiperSlide>

              {/* Duplicate slides for continuous loop */}
              <SwiperSlide>
                <img src={Img1} alt="" className="mx-auto mb-2" />
                <span className="font-custom text-[25px] text-center block">Sports</span>
              </SwiperSlide>
              <SwiperSlide>
                <img src={Img2} alt="" className="mx-auto mb-2" />
                <span className="font-custom text-[25px] text-center block">School</span>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default Template;
